// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"270":"1224cabe","398":"d1308c60"}[chunkId] + ".js";
};